import React from 'react';

import { bemBlock } from '../../modules/bem';

import { useTableContext } from './TableContext';

import './TableCell.less';

const block = bemBlock('table-cell');

export type TableCellAlign = 'left' | 'center' | 'right';

export type TableCellProps = React.TdHTMLAttributes<HTMLTableCellElement> & {
  align?: TableCellAlign;
  spacer?: boolean;
  virtualized?: boolean;
};

export const TableCell = React.forwardRef<HTMLTableCellElement, TableCellProps>(function TableCell(
  { align = 'left', className, spacer = false, virtualized = false, ...passProps },
  ref,
) {
  const { shouldVirtualize } = useTableContext();

  return (
    <td
      ref={ref}
      className={block({
        modifiers: {
          align,
          spacer,
          virtualized: shouldVirtualize && virtualized,
        },
        extra: className,
      })}
      {...passProps}
    />
  );
});
